<div class="workspace-page workspace-page--full br-compact-page">
  <div class="workspace-page__panel workspace-page__panel--card">
    <header class="workspace-page__heading">
      <h1 class="workspace-page__title">{{ title }}</h1>
    </header>
    <app-leads-v2-workflow-config
        [workflowKey]="workflowKey"
        [createMode]="createMode"
        (workflowCreated)="onWorkflowCreated($event)"
        (backRequested)="onBackRequested()" />
  </div>
</div>
